import { useIntl } from "@/i18n/i18n-client";

const LeftArrow = ({ rotateOnRTL = false }: { rotateOnRTL?: boolean }) => {
  const locale = useIntl();
  const isRTL = locale.locale === "ar-EG";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      style={{ transform: isRTL && rotateOnRTL ? "rotate(180deg)" : "" }}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.74"
      >
        <path
          d="M0 6.09L12.18 6.09M6.09 0L12.18 6.09 6.09 12.18"
          transform="matrix(-1 0 0 1 14 1)"
        />
      </g>
    </svg>
  );
};

export { LeftArrow };
